import { TimeSeriesMeasurementPoint } from "../../timeseries-statistics/model/TimeSeriesMeasurement.model";
import { Timestamp } from "../../timeseries-statistics/model/Timestamp.model";

export type BitRateMetric = 'txBitRate' | 'rxBitRate' | 'outgoingTraffic' | 'incomingTraffic';
export interface NetworkServiceBitrateApiModel {
  timestamp: Timestamp;
  txBitRate: number;
  rxBitRate: number;
}

export interface NetworkServiceBitrateViewModel {
  time: Date[];
  txBitRate: number[];
  rxBitRate: number[];
  outgoingTraffic: number[];
  incomingTraffic: number[];
}

export const mapNetworkServiceBitrateApiModelToNetworkServiceBitrateViewModel = (
  apiMeasurements: NetworkServiceBitrateApiModel[],
  throughput: number
): NetworkServiceBitrateViewModel => {
  const measurement: NetworkServiceBitrateViewModel = {
    time: [],
    txBitRate: [],
    rxBitRate: [],
    outgoingTraffic: [],
    incomingTraffic: [],
  };
  apiMeasurements.forEach(apiMeasurement => {
    measurement.txBitRate.push(apiMeasurement.txBitRate);
    measurement.rxBitRate.push(apiMeasurement.rxBitRate);
    measurement.outgoingTraffic.push(apiMeasurement.txBitRate / throughput * 100);
    measurement.incomingTraffic.push(apiMeasurement.rxBitRate / throughput * 100);
    measurement.time.push(new Date(apiMeasurement.timestamp));
  });
  return measurement;
};

export const buildSeriesData = (
  measurement: NetworkServiceBitrateViewModel,
  metric: BitRateMetric,
) : TimeSeriesMeasurementPoint[] =>
  measurement.time.map((time, index) => ({
    x: time.getTime(),
    y: measurement[metric][index]
  }));